import { AmountValue, YearAndMonth, Role } from 'common/interfaces';
import { ForeignIdType } from 'stores/workflowStores/workflowPersonalDataStore/model';
//import { ClassesAsset } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces';
import { Currency, AccountMode } from 'enums';

export enum PdfCategory {
  REQUEST = 'REQUEST',
  SIGNATURE = 'SIGN',
  STATEMENT = 'STATEMENT'
}

export interface CommonPdfContent {
  header: HeaderData;
  currency: Currency;
  signedInfo: boolean;
}

export interface Address {
  street: string;
  landRegistryNumber: string;
  houseNumber: string;
  city: string;
  postalCode: string;
  country: string;
}

interface ContactData {
  email: string;
  phone: string;
}

//******************/

interface Company {
  companyNumber: string;
  companyName: string;
  code: string;
}

interface Intermediate {
  dataProtectionUrl?: string;
  informationUrl?: string;
  headquarters?: string;
  regStatement?: string;
}

export interface AdvisorData {
  firstname: string;
  lastname: string;
  contacts: ContactData;
  role: Role;
  code?: string;
}

export interface ClientData {
  analyzePersonalInformation: true;
  birthDate: string;
  contactData: ContactData;
  firstname: string;
  identificationNumber: string;
  foreignIdType: ForeignIdType;
  lastname: string;
  permanentAddress: Address;
  permanentAddressCompact: string;
  providingContactsToThirdParty: true;
  companyName: string;
  companyNumber: string;
  phone: string;
  email: string;
}

export interface HeaderData {
  client: ClientData;
  advisor: AdvisorData;
  title: string;
  accountTitle: string;
  partnerCompany: Company;
  intermediaryCompany: Company & Intermediate;
  signedVia: string;
  mode: AccountMode;
}

// Buckets:
/*
interface Asset extends ClassesAsset {
  statement: {
    pieces: AmountValue;
    price: AmountValue;
    originalValue: AmountValue;
    exchangeRate: AmountValue;
    convertedValue: AmountValue;
  };
}

interface AssetClass {
  share: number;
  title: string;
  assets?: Asset[];
}
export interface AssetCategory {
  code: string;
  assetClasses: AssetClass[];
}
*/
/*
export interface Portfolio {
  code: PortfolioCode;
  income: number;
  loss: number;
  assetTotal?: AmountValue | null;
  terAverage: number;
  distributionTotal: number;
  assetCategories: AssetCategory[];
  chart: {
    dataset: {};
  };
  msciRating?: number;
  carbon?: number;
}
*/
/*
export interface PlanBucketData {
  riskProfile: string;
  originalRiskProfile: string;
  title: string;
  subtitle: string;
  balance: AmountValue;
  portfolio: Portfolio;
  currencyHedging?: boolean;
  automaticRebalancing?: boolean;
  active: boolean;
}
*/
export interface Period {
  value: { value: number };
  horizon: string;
  until: string;
}

export interface ReservesData {
  shortTerm: Period;
  midTerm: Period;
}

export interface RentData {
  start: string;
  calculatedAllowance: AmountValue;
  plannedAllowance?: AmountValue;
  durability?: YearAndMonth;
  partnerDurability: YearAndMonth | null;
}
